export default __webpack_public_path__ + "static/media/importCsv.1f469c42.svg";